/// <amd-module name="typeahead/features/ShowFlightBookingSuggestion" />
import {EmptyQueryDataProvider} from "typeahead/core/EmptyQueryDataProvider";
import {IDataProviderResponse} from "typeahead/core/IDataProvider";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import {IFocusSuggester} from "typeahead/core/IFocusSuggester";
import {ISuggesterResponse} from "typeahead/core/ISuggester";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {IEssSuggestionResult} from "typeahead/core/Suggestion";
import {SuggestionCategory} from "typeahead/core/Suggestion";
import {SuggesterId} from "typeahead/core/SuggestionsAggregator";

const configuration: IStripingConfiguration[] = [
    {
        clients: ["Homepage", "CarsLandingPage"],
        experiment: {
            id: 14235,
            name: "SuggestRegionInCars",
            value: 1,
        },
        tabs: ["car"],
    },
    {
        clients: ["Homepage"],
        experiment: {
            id: 14236,
            name: "SuggestRegionInLX",
            value: 1,
        },
        tabs: ["activity"],
    },
    {
        clients: ["LXLandingPage"],
        experiment: {
            id: 14236,
            name: "SuggestRegionInLX",
            value: 1,
        },
    },
];

export class ShowFlightBookingSuggestion implements IPageLoadHandler, IFocusSuggester, IExperimentalFeature  {

    private results: IEssSuggestionResult[];

    public getId(): SuggesterId {
        return SuggesterId.FlightBookingSuggester;
    }

    public handlePageLoad(options: any, context: IContext): JQueryPromise<undefined> {
        let deferred: JQueryDeferred<undefined> = $.Deferred();
        let opts = $.extend(true, {}, {options, context});
        new EmptyQueryDataProvider().fetchData(opts).then((response: IDataProviderResponse) => {
            this.results = this.filterFlightBookingResults(<IEssSuggestionResult[]> response.results);
            deferred.resolve();
        });
        return deferred.promise();
    }

    public suggestOnFocus(options: any, context: IContext): JQueryPromise<ISuggesterResponse> {
        return this.suggest(options, context);
    }

    public suggest(options: any, context: IContext): JQueryPromise<ISuggesterResponse> {
        let deferred: JQueryDeferred<ISuggesterResponse> = $.Deferred();
        ExecutionHelper.shouldExecute(context, configuration)
            .done((shouldExecute) => {
                if (shouldExecute) {
                    deferred.resolve({
                        id: this.getId(),
                        results: this.getApplicableFlightBookingResult(this.getLob(context)),
                    });
                }
            }).always(() => {
                deferred.resolve({id: this.getId(), results: []});
            });
        return deferred.promise();
    }

    public getExperiments(): UtaExperiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    private getApplicableFlightBookingResult(lob: string) {
        let lobFilter = (result: IEssSuggestionResult) => {
            return result.targetHtmlElements && result.targetHtmlElements.indexOf(lob) > -1;
        };
        return this.results.filter(lobFilter);
    }

    private filterFlightBookingResults(results: IEssSuggestionResult[]): IEssSuggestionResult[] {
        let flightBookingFilter = (result: IEssSuggestionResult) => {
            return result.category === SuggestionCategory[SuggestionCategory.FLIGHTSBOOKING];
        };
        if (results && results.length) {
            return results.filter(flightBookingFilter);
        } else {
            return [];
        }
    }

    private getLob(context): string {
        return context.tab ? context.tab : (context.clientId === "LXLandingPage") ? "activity" : "";
    }
}
